<template>
    <div class="game_info">
        <van-overlay :show="infoShow">
            <div class="game_info_wrapper">
                <div class="game_info_wrapper_pic">
                    退出
                </div>
                <p>{{infoMsg}}</p>
                <div class="game_info_wrapper_button">
                     <div class="game_info_wrapper_button_no" @click="close">
                         否
                     </div>
                     <div class="game_info_wrapper_button_yes" @click="goback">
                         是
                     </div>
                </div>
            </div>
        </van-overlay>
    </div>
</template>
<script>
export default {
    name: 'goback-info',
    props:['infoShow','infoMsg'],
    data () {
        return {

        }
    },
    methods:{
        close() {
            this.$emit('infoClose');
        },
        goback() {
            this.$emit('goback');
        }
    }
}
</script>
<style lang='scss' scoped>
.van-overlay {
    z-index: 99;
    display: flex;
    justify-content: center;
    align-items: center;
    .game_info_wrapper {
        width: 248px;
        height: 173px;
        background: url(./../../assets/images/game/info.png);
        background-size: cover;
        position: relative;
        .game_info_wrapper_pic {
            width: 182px;
            height: 49px;
            text-align: center;
            font-size: 16px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #FFFFFF;
            line-height: 44px;
            background: url(./../../assets/images/game/tui.png);
            background-size: cover;
            margin-left: 33px;
            margin-top: -30px;
        }
        p {
            font-size: 16px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #666666;
            text-align: center;
            margin-top: 30px;
        }
        .game_info_wrapper_button {
            display: flex;
            justify-content: center;
            margin-top: 40px;
            .game_info_wrapper_button_no {
                width: 86px;
                height: 31px;
                background: url(./../../assets/images/game/no.png);
                background-size: cover;
                font-size: 16px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                color: #FFFFFF;
                line-height: 31px;
                text-shadow: 0px 2px 1px #6381FF;
                text-align: center;
            }
            .game_info_wrapper_button_yes {
                width: 86px;
                height: 31px;
                background: url(./../../assets/images/game/yes.png);
                background-size: cover;
                margin-left: 12px;
                font-size: 16px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                color: #FFFFFF;
                line-height: 31px;
                text-shadow: 0px 2px 1px #fe8c62;
                text-align: center;
            }
        }
    }
}

</style>
